import React, { FC, memo, useMemo } from "react";

// styles
import { PlanPurchaseOneTapCTA } from "./styles";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// types
import { CART_UPSELL_TEST_IDS } from "@super-ui/components/cart-upsell-nudge";

// helpers
import { checkCtaType } from "@super-ui/components/cart-upsell-nudge/helpers";

interface OneTapCtaProps {
    text: string;
    link: string;
    type: string;
    handleOneTapClick: () => void;
    isCartV2?: boolean;
    isBlackPlan: boolean;
}

const OneTapCta: FC<OneTapCtaProps> = ({ text, type, handleOneTapClick, isCartV2, isBlackPlan = false }) => {
    const isOneTapAddCta = useMemo(() => checkCtaType(type), [type]);

    const ctaColor = useMemo(() => {
        if (isOneTapAddCta) {
            return isBlackPlan ? "secondary_One_Blck" : "positive";
        }
        return "text_High_Emphasis";
    }, [isOneTapAddCta, isBlackPlan]);

    return (
        <PlanPurchaseOneTapCTA
            data-testid={CART_UPSELL_TEST_IDS.ONE_TAP_CTA}
            onClick={handleOneTapClick}
            isCartV2={isCartV2}
            isBlackPlan={isBlackPlan}
            isOneTapAddCta={isOneTapAddCta}
        >
            <Text data-testid={CART_UPSELL_TEST_IDS.ONE_TAP_CTA_TEXT} variant="V2.body3.neutral.bold" color={ctaColor}>
                {text}
            </Text>
        </PlanPurchaseOneTapCTA>
    );
};

export default memo(OneTapCta);
